<template>
    <div>
        <limitless-page-header :title="'Att göra'" :sub-title="plan_name"></limitless-page-header>

        <div class="content">
            <div class="row mb-3">
                <div class="col-12 col-md-3">
                    <v-date-picker
                        v-model="date"
                        mode="date"
                        :locale="{ id: 'sv', firstDayOfWeek: 2, masks: { weekdays: 'WW', input: 'YYYY-MM-DD' } }"
                        :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
                        show-iso-weeknumbers
                    >
                        <template v-slot="{ inputValue, togglePopover }">
                            <input class="form-control" :value="inputValue" @focus="togglePopover()">
                        </template>
                    </v-date-picker>
                </div>
            </div>

            <div v-if="busy_loading">
                <i class="icon-spinner2 spinner"></i>
            </div>
            <div v-else class="row">
                <div class="col-12">
                    <div v-if="todo" class="card-group-control card-group-control-right">
                        <div class="card">
                            <div class="card-header bg-white">
                                <h5 class="card-title">
                                    <a data-toggle="collapse" class="text-body" href="#todo-group1">Skörda</a>
                                </h5>
                            </div>

                            <div id="todo-group1" class="collapse show">
                                <div
                                    v-if="(todo.main.harvest && Object.keys(todo.main.harvest).length > 0) || (todo.extra.harvest && Object.keys(todo.extra.harvest).length > 0)"
                                    class="card-table" style="border-bottom-style: solid; border-bottom-color: #186632 !important; border-bottom-width: 2px;"
                                >
                                    <table class="table table-striped table-xs">
                                        <thead>
                                            <tr>
                                                <th style="width: 200px;">Gröda</th>
                                                <th style="width: 100px;">Antal (Behov)</th>
                                                <th style="width: 200px;">Label</th>
                                                <th></th>
                                                <th style="width: 300px;"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="todo.main.harvest && Object.keys(todo.main.harvest).length > 0">
                                                <tr>
                                                    <th colspan="5">{{ todo.main._metadata.unit.name }}</th>
                                                </tr>
                                                <template v-for="(layer, hl_idx) in todo.main.harvest">
                                                    <tr style="border-top-style: solid; border-top-color: #186632 !important; border-top-width: 2px;" :key="'hl-main-' + hl_idx">
                                                        <th colspan="5" style="text-decoration: underline;">{{ todo.main._metadata.layers[hl_idx].title }}</th>
                                                    </tr>
                                                    <tr v-for="crop in layer" :key="'hl-main-' + hl_idx + '-c-' + crop.id">
                                                        <th>{{ crop.name }}</th>
                                                        <td>{{ crop.quantity }}</td>
                                                        <td>{{ crop.label }}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </template>
                                            </template>
                                            <template v-if="todo.extra.harvest && Object.keys(todo.extra.harvest).length > 0">
                                                <tr v-if="todo.main.harvest && Object.keys(todo.main.harvest).length > 0">
                                                    <th colspan="5">&nbsp;</th>
                                                </tr>
                                                <tr>
                                                    <th colspan="5">{{ todo.extra._metadata.unit.name }}</th>
                                                </tr>
                                                <template v-for="(layer, hl_idx) in todo.extra.harvest">
                                                    <tr style="border-top-style: solid; border-top-color: #186632 !important; border-top-width: 2px;" :key="'hl-extra-' + hl_idx">
                                                        <th colspan="5" style="text-decoration: underline;">{{ todo.extra._metadata.layers[hl_idx].title }}</th>
                                                    </tr>
                                                    <tr v-for="crop in layer" :key="'hl-extra-' + hl_idx + '-c-' + crop.id">
                                                        <th>{{ crop.name }}</th>
                                                        <td>{{ crop.quantity }}</td>
                                                        <td>{{ crop.label }}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else class="card-body">
                                    <i>Inget att skörda</i>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header bg-white">
                                <h5 class="card-title">
                                    <a data-toggle="collapse" class="text-body" href="#todo-group2">Placera i tillväxtzon</a>
                                </h5>
                            </div>

                            <div id="todo-group2" class="collapse show">
                                <div
                                    v-if="(todo.main.transplant && Object.keys(todo.main.transplant).length > 0) || (todo.extra.transplant && Object.keys(todo.extra.transplant).length > 0)"
                                    class="card-table" style="border-bottom-style: solid; border-bottom-color: #186632 !important; border-bottom-width: 2px;"
                                >
                                    <table class="table table-striped table-xs">
                                        <thead>
                                            <tr>
                                                <th style="width: 200px;">Gröda</th>
                                                <th style="width: 100px;">Antal (Behov)</th>
                                                <th style="width: 200px;">Label</th>
                                                <th></th>
                                                <th style="width: 300px;"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="todo.main.transplant && Object.keys(todo.main.transplant).length > 0">
                                                <tr>
                                                    <th colspan="5">{{ todo.main._metadata.unit.name }}</th>
                                                </tr>
                                                <template v-for="(layer, tl_idx) in todo.main.transplant">
                                                    <tr style="border-top-style: solid; border-top-color: #186632 !important; border-top-width: 2px;" :key="'tl-main-' + tl_idx">
                                                        <th colspan="5" style="text-decoration: underline; font-size: 14px;">{{ todo.main._metadata.layers[tl_idx].title }}</th>
                                                    </tr>
                                                    <tr v-for="crop in layer" :key="'tl-main-' + tl_idx + '-c-' + crop.id">
                                                        <th>{{ crop.name }}</th>
                                                        <td>{{ crop.quantity }}</td>
                                                        <td>{{ crop.label }}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr :key="'tl-main-' + tl_idx + '-total'">
                                                        <th colspan="5" style=""><i v-text="getLayerTotalText(layer, tl_idx, todo.main._metadata)"></i></th>
                                                    </tr>
                                                </template>
                                            </template>
                                            <template v-if="todo.extra.transplant && Object.keys(todo.extra.transplant).length > 0">
                                                <tr v-if="todo.main.transplant && Object.keys(todo.main.transplant).length > 0">
                                                    <th colspan="5">&nbsp;</th>
                                                </tr>
                                                <tr>
                                                    <th colspan="5">{{ todo.extra._metadata.unit.name }}</th>
                                                </tr>
                                                <template v-for="(layer, tl_idx) in todo.extra.transplant">
                                                    <tr style="border-top-style: solid; border-top-color: #186632 !important; border-top-width: 2px;" :key="'tl-extra-' + tl_idx">
                                                        <th colspan="5" style="text-decoration: underline; font-size: 14px;">{{ todo.extra._metadata.layers[tl_idx].title }}</th>
                                                    </tr>
                                                    <tr v-for="crop in layer" :key="'tl-extra-' + tl_idx + '-c-' + crop.id">
                                                        <th>{{ crop.name }}</th>
                                                        <td>{{ crop.quantity }}</td>
                                                        <td>{{ crop.label }}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr :key="'tl-extra-' + tl_idx + '-total'">
                                                        <th colspan="5" style=""><i v-text="getLayerTotalText(layer, tl_idx, todo.extra._metadata)"></i></th>
                                                    </tr>
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else class="card-body">
                                    <i>Inget att plantera</i>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header bg-white">
                                <h5 class="card-title">
                                    <a data-toggle="collapse" class="text-body" href="#todo-group3">Flytta till barnkammaren</a>
                                </h5>
                            </div>

                            <div id="todo-group3" class="collapse show">
                                <div
                                    v-if="(todo.main.nursery && Object.keys(todo.main.nursery).length > 0) || (todo.extra.nursery && Object.keys(todo.extra.nursery).length > 0)"
                                    class="card-table" style="border-bottom-style: solid; border-bottom-color: #186632 !important; border-bottom-width: 2px;"
                                >
                                    <table class="table table-striped table-xs">
                                        <thead>
                                            <tr>
                                                <th style="width: 200px;">Gröda</th>
                                                <th style="width: 100px;">Antal (Behov)</th>
                                                <th style="width: 200px;">Label</th>
                                                <th></th>
                                                <th style="width: 300px;"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="todo.main.nursery && Object.keys(todo.main.nursery).length > 0">
                                                <tr>
                                                    <th colspan="5">{{ todo.main._metadata.unit.name }}</th>
                                                </tr>
                                                <template v-for="(tray, nt_idx) in todo.main.nursery">
                                                    <tr style="border-top-style: solid; border-top-color: #186632 !important; border-top-width: 2px;" :key="'nt-main-' + nt_idx">
                                                        <th colspan="5">Bricka {{ nt_idx + 1 }} - {{ tray.nursery_date }}</th>
                                                    </tr>
                                                    <tr v-for="crop in tray.crops" :key="'nt-main-' + nt_idx + '-c-' + crop.id">
                                                        <th>{{ crop.name }}</th>
                                                        <td>{{ crop.sow_quantity }} ({{ crop.quantity }})</td>
                                                        <td>{{ crop.label }}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </template>
                                            </template>
                                            <template v-if="todo.extra.nursery && Object.keys(todo.extra.nursery).length > 0">
                                                <tr v-if="todo.main.nursery && Object.keys(todo.main.nursery).length > 0">
                                                    <th colspan="5">&nbsp;</th>
                                                </tr>
                                                <tr>
                                                    <th colspan="5">{{ todo.extra._metadata.unit.name }}</th>
                                                </tr>
                                                <template v-for="(tray, nt_idx) in todo.extra.nursery">
                                                    <tr style="border-top-style: solid; border-top-color: #186632 !important; border-top-width: 2px;" :key="'nt-extra-' + nt_idx">
                                                        <th colspan="5">Bricka {{ nt_idx + 1 }} - {{ tray.nursery_date }}</th>
                                                    </tr>
                                                    <tr v-for="crop in tray.crops" :key="'nt-extra-' + nt_idx + '-c-' + crop.id">
                                                        <th>{{ crop.name }}</th>
                                                        <td>{{ crop.sow_quantity }} ({{ crop.quantity }})</td>
                                                        <td>{{ crop.label }}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else class="card-body">
                                    <i>Inget att flytta till barnkammaren</i>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header bg-white">
                                <h5 class="card-title">
                                    <a data-toggle="collapse" class="text-body" href="#todo-group4">Så</a>
                                </h5>
                            </div>

                            <div id="todo-group4" class="collapse show">
                                <div
                                    v-if="(todo.main.sow && Object.keys(todo.main.sow).length > 0) || (todo.extra.sow && Object.keys(todo.extra.sow).length > 0)"
                                    class="card-table"
                                    style="border-bottom-style: solid; border-bottom-color: #186632 !important; border-bottom-width: 2px;"
                                >
                                    <table class="table table-striped table-xs">
                                        <thead>
                                            <tr>
                                                <th style="width: 200px;">Gröda</th>
                                                <th style="width: 100px;">Antal (Behov)</th>
                                                <th style="width: 200px;">Label</th>
                                                <th>Instruktion</th>
                                                <th style="width: 300px;"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="todo.main.sow && Object.keys(todo.main.sow).length > 0">
                                                <tr>
                                                    <th colspan="5">{{ todo.main._metadata.unit.name }}</th>
                                                </tr>
                                                <template v-for="(tray, st_idx) in todo.main.sow">
                                                    <tr style="border-top-style: solid; border-top-color: #186632 !important; border-top-width: 2px;" :key="'st-main-' + st_idx">
                                                        <th colspan="5">Bricka {{ st_idx + 1 }}, Flyttas till barnkammaren {{ tray.nursery_date }}</th>
                                                    </tr>
                                                    <tr v-for="crop in tray.crops" :key="'st-main-' + st_idx + '-c-' + crop.id">
                                                        <th>{{ crop.name }}</th>
                                                        <td>{{ crop.sow_quantity }} ({{ crop.quantity }})</td>
                                                        <td>{{ crop.label }}</td>
                                                        <td>
                                                            <span v-if="crop.instructions"><i class="icon-info22"></i> {{ crop.instructions }}</span>
                                                        </td>
                                                        <td>
                                                            <span v-if="crop.direct_nursery"><i class="icon-info22"></i> Placeras direkt i barnkammaren</span>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                            <template v-if="todo.extra.sow && Object.keys(todo.extra.sow).length > 0">
                                                <tr v-if="todo.main.sow && Object.keys(todo.main.sow).length > 0">
                                                    <th colspan="5">&nbsp;</th>
                                                </tr>
                                                <tr>
                                                    <th colspan="5">{{ todo.extra._metadata.unit.name }}</th>
                                                </tr>
                                                <template v-for="(tray, st_idx) in todo.extra.sow">
                                                    <tr style="border-top-style: solid; border-top-color: #186632 !important; border-top-width: 2px;" :key="'st-extra-' + st_idx">
                                                        <th colspan="5">Bricka {{ st_idx + 1 }}, Flyttas till barnkammaren {{ tray.nursery_date }}</th>
                                                    </tr>
                                                    <tr v-for="crop in tray.crops" :key="'st-extra-' + st_idx + '-c-' + crop.id">
                                                        <th>{{ crop.name }}</th>
                                                        <td>{{ crop.sow_quantity }} ({{ crop.quantity }})</td>
                                                        <td>{{ crop.label }}</td>
                                                        <td>
                                                            <span v-if="crop.instructions"><i class="icon-info22"></i> {{ crop.instructions }}</span>
                                                        </td>
                                                        <td>
                                                            <span v-if="crop.direct_nursery"><i class="icon-info22"></i> Placeras direkt i barnkammaren</span>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else class="card-body">
                                    <i>Inget att så</i>
                                </div>
                            </div>
                        </div>
                    </div> <!-- /card-group -->
                    <div v-else>
                        <i>Hittade inget att göra...</i>
                    </div>
                </div>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Limitless/LimitlessPageHeader';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import { startOfWeek } from '@services/Helpers';

export default {
    name: 'ToDo',
    components: {
        LimitlessPageHeader,
        VDatePicker,
    },
    data: () => ({
        busy_loading: true,
        date: null,
        todo: null,
    }),
    mounted() {
        this.date = new Date().toLocaleString('sv-SE').substr(0, 10);
    },
    methods: {
        getToDo() {
            this.busy_loading = true;
            apiClient.get('/vue/todo/' + this.date)
                .then((response) => {
                    this.todo = response.data;
                })
                .finally(() => {
                    this.busy_loading = false;
                });
        },
        getLayerTotalText(layer, idx, metadata) {
            let totalCrops = 0;
            if (layer && Array.isArray(layer)) {
                layer.forEach((crop) => {
                    totalCrops += crop.quantity;
                });
            }
            // eslint-disable-next-line no-underscore-dangle
            return 'Totalt ' + totalCrops + ' plantor behöver ' + Math.ceil(totalCrops / metadata.layers[idx].plugs) + ' brickor (' + metadata.layers[idx].plugs + ' plantor / bricka)';
        },
    },
    watch: {
        date() {
            this.getToDo();
        },
    },
    computed: {
        plan_name() {
            return this.date;
        },
        weekdays() {
            const arr = [];
            if (this.date) {
                const dateparts = this.date.split('-');
                if (dateparts) {
                    const date = startOfWeek(new Date(dateparts[0], dateparts[1] - 1, dateparts[2]));

                    // eslint-disable-next-line no-plusplus
                    for (let i = 0; i < 7; i++) {
                        arr.push({
                            date: date.toLocaleString('sv-SE').substr(0, 10),
                            day: date.toLocaleString('sv-SE', { weekday: 'long' }),
                        });
                        date.setDate(date.getDate() + 1);
                    }
                }
            }
            return arr;
        },
    },
};
</script>
